import React from 'react';
import './Calendar.css';

function Calendar({ date, attendance = {}, onDateSelect }) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const monthName = date.toLocaleString('default', { month: 'long' });

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const startDay = new Date(year, month, 1).getDay();

  const getStatusClass = (dateStr) => {
    const status = attendance[dateStr];
    if (status === 'present') return 'present-day';
    if (status === 'absent') return 'absent-day';
    if (status === 'leave') return 'leave-day';
    return 'default-day';
  };

  const getStatusLabel = (dateStr) => {
    const status = attendance[dateStr];
    if (status === 'present') return 'Present';
    if (status === 'absent') return 'Absent';
    if (status === 'leave') return 'Leave';
    return '';
  };

  const dates = [];

  // Add empty cells for days before the 1st
  for (let i = 0; i < startDay; i++) {
    dates.push(
      <div key={`blank-${i}`} className="calendar-cell empty-cell"></div>
    );
  }

  // Add actual days of the month
  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    dates.push(
      <div
        key={dateStr}
        className={`calendar-cell ${getStatusClass(dateStr)}`}
        onClick={() => onDateSelect?.(new Date(dateStr))}
        title={`Click to view ${getStatusLabel(dateStr) || 'details'} on ${dateStr}`}
      >
        <div className="day-number">{day}</div>
        <div className="small">{getStatusLabel(dateStr)}</div>
      </div>
    );
  }

  return (
    <div className="text-center">
      <h3 className="mb-3">{monthName} {year}</h3>

      {/* Optional: Legend */}
      <div className="d-flex justify-content-center gap-3 mb-3 flex-wrap">
        <span className="badge bg-success-subtle border text-dark">
          Present
        </span>
        <span className="badge bg-danger-subtle border text-dark">
          Absent
        </span>
        {/* <span className="badge bg-warning-subtle border text-dark">
          Leave
        </span> */}
      </div>

      {/* Calendar Grid */}
      <div className="calendar-grid">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
          <div
            key={day}
            className="calendar-cell calendar-header fw-bold text-uppercase"
          >
            {day}
          </div>
        ))}
        {dates}
      </div>
    </div>
  );
}

export default Calendar;
